import * as Yup from 'yup';

export const categoryValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('กรุณากรอกชื่อหมวดหมู่')
    .min(3, 'ชื่อหมวดหมู่ต้องมีอย่างน้อย 3 ตัวอักษร')
    .max(50, 'ชื่อหมวดหมู่ต้องไม่เกิน 50 ตัวอักษร'),
  
  description: Yup.string()
    .max(200, 'คำอธิบายหมวดหมู่ต้องไม่เกิน 200 ตัวอักษร'),
  
  isActive: Yup.boolean()
    .required('กรุณาเลือกสถานะการใช้งาน')
}); 